import { useQuery } from '@tanstack/react-query'
import { apiRequest, UploadTask, PaginatedResponse } from '../services/api'

export function UploadsPage() {
  const { data: uploads, isLoading } = useQuery({
    queryKey: ['uploads'],
    queryFn: () => apiRequest<PaginatedResponse<UploadTask>>('/api/v1/upload/tasks'),
  })
  
  if (isLoading) {
    return <div className="flex items-center justify-center h-64">Loading...</div>
  }
  
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Uploads</h1>
        <p className="text-gray-600">Monitor upload tasks</p>
      </div>
      
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">File</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Size</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Progress</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Device</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Created</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {uploads?.data?.map((upload: UploadTask) => (
              <tr key={upload.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{upload.file_name}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 capitalize">{upload.type}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {upload.file_size ? (upload.file_size / 1024 / 1024).toFixed(2) + ' MB' : 'N/A'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                    upload.status === 'completed' ? 'bg-green-100 text-green-800' :
                    upload.status === 'uploading' ? 'bg-blue-100 text-blue-800' :
                    upload.status === 'failed' ? 'bg-red-100 text-red-800' :
                    upload.status === 'paused' ? 'bg-yellow-100 text-yellow-800' :
                    'bg-gray-100 text-gray-800'
                  }`}>
                    {upload.status}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="w-32 bg-gray-200 rounded-full h-2">
                    <div 
                      className="bg-blue-600 h-2 rounded-full transition-all"
                      style={{ width: `${upload.progress * 100}%` }}
                    />
                  </div>
                  <span className="text-xs text-gray-500 ml-1">{(upload.progress * 100).toFixed(1)}%</span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {upload.device_id.slice(0, 8)}...
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {new Date(upload.created_at).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        
        {!uploads?.data?.length && (
          <div className="px-6 py-12 text-center text-gray-500">
            No upload tasks found
          </div>
        )}
      </div>
    </div>
  )
}
